"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("./constants");
var MatomoTracker = /** @class */ (function () {
    function MatomoTracker(userOptions) {
        var options = __assign(__assign({}, constants_1.defaultOptions), userOptions);
        if (!options.urlBase) {
            throw new Error('Matomo urlBase is required.');
        }
        MatomoTracker.initialize(options);
    }
    // Initializes the Matomo Tracker
    MatomoTracker.initialize = function (_a) {
        var urlBase = _a.urlBase, siteId = _a.siteId, trackerUrl = _a.trackerUrl, srcUrl = _a.srcUrl;
        if (urlBase[urlBase.length - 1] !== '/') {
            urlBase = urlBase + '/';
        }
        window._paq = window._paq || [];
        if (window._paq.length === 0) {
            window._paq.push(['setTrackerUrl', trackerUrl || urlBase + "matomo.php"]);
            window._paq.push(['setSiteId', siteId]);
            // accurately measure the time spent on the last pageview of a visit
            window._paq.push(['enableHeartBeatTimer']);
            // measure outbound links and downloads
            // might not work accurately on SPAs because new links (dom elements) are created dynamically without a server-side page reload.
            window._paq.push(['enableLinkTracking']);
            var doc = document;
            var scriptElement = doc.createElement('script');
            var scripts = doc.getElementsByTagName('script')[0];
            scriptElement.type = 'text/javascript';
            scriptElement.async = true;
            scriptElement.defer = true;
            scriptElement.src = srcUrl || urlBase + "matomo.js";
            if (scripts && scripts.parentNode) {
                scripts.parentNode.insertBefore(scriptElement, scripts);
            }
        }
    };
    // Tracks events based on data attributes
    MatomoTracker.prototype.trackEvents = function () {
        var _this = this;
        var elements = Array.from(document.querySelectorAll('[data-matomo-event="click"]'));
        if (elements.length) {
            elements.forEach(function (element) {
                element.addEventListener('click', function () {
                    var _a = element.dataset, matomoCategory = _a.matomoCategory, matomoAction = _a.matomoAction, matomoName = _a.matomoName, matomoValue = _a.matomoValue;
                    if (matomoCategory && matomoAction) {
                        _this.trackEvent({
                            category: matomoCategory,
                            action: matomoAction,
                            name: matomoName,
                            value: Number(matomoValue),
                        });
                    }
                    else {
                        throw new Error("Error: data-matomo-category and data-matomo-action are required.");
                    }
                });
            });
        }
    };
    // Tracks events
    // https://matomo.org/docs/event-tracking/#tracking-events
    MatomoTracker.prototype.trackEvent = function (_a) {
        var category = _a.category, action = _a.action, name = _a.name, value = _a.value, otherParams = __rest(_a, ["category", "action", "name", "value"]);
        if (category && action) {
            this.track(__assign({ data: [constants_1.TRACK_TYPES.TRACK_EVENT, category, action, name, value] }, otherParams));
        }
        else {
            throw new Error("Error: category and action are required.");
        }
    };
    // Tracks site search
    // https://developer.matomo.org/guides/tracking-javascript-guide#internal-search-tracking
    MatomoTracker.prototype.trackSiteSearch = function (_a) {
        var keyword = _a.keyword, category = _a.category, count = _a.count, otherParams = __rest(_a, ["keyword", "category", "count"]);
        if (keyword) {
            this.track(__assign({ data: [constants_1.TRACK_TYPES.TRACK_SEARCH, keyword, category, count] }, otherParams));
        }
        else {
            throw new Error("Error: keyword is required.");
        }
    };
    // Tracks outgoing links to other sites and downloads
    // https://developer.matomo.org/guides/tracking-javascript-guide#enabling-download-outlink-tracking
    MatomoTracker.prototype.trackLink = function (_a) {
        var href = _a.href, _b = _a.linkType, linkType = _b === void 0 ? 'link' : _b;
        window._paq.push([constants_1.TRACK_TYPES.TRACK_LINK, href, linkType]);
    };
    // Tracks page views
    // https://developer.matomo.org/guides/spa-tracking#tracking-a-new-page-view
    MatomoTracker.prototype.trackPageView = function (params) {
        this.track(__assign({ data: [constants_1.TRACK_TYPES.TRACK_VIEW] }, params));
    };
    // Sends the tracked page/view/search to Matomo
    MatomoTracker.prototype.track = function (_a) {
        var _b = _a.data, data = _b === void 0 ? [] : _b, _c = _a.documentTitle, documentTitle = _c === void 0 ? window.document.title : _c, _d = _a.href, href = _d === void 0 ? window.location.href : _d, _e = _a.customDimensions, customDimensions = _e === void 0 ? false : _e;
        if (data.length) {
            if (customDimensions &&
                Array.isArray(customDimensions) &&
                customDimensions.length) {
                customDimensions.map(function (customDimension) {
                    return window._paq.push([
                        'setCustomDimension',
                        customDimension.id,
                        customDimension.value,
                    ]);
                });
            }
            window._paq.push(['setCustomUrl', href]);
            window._paq.push(['setDocumentTitle', documentTitle]);
            window._paq.push(data);
        }
    };
    return MatomoTracker;
}());
exports.default = MatomoTracker;
//# sourceMappingURL=MatomoTracker.js.map